import React from 'react';
import { Card, Tabs, Form, Input, Button, Switch, message } from 'antd';
import { UserOutlined, LockOutlined, SettingOutlined } from '@ant-design/icons';
import { useAuthStore } from '@/stores/authStore';
import { authApi } from '@/services/api';

const Settings = () => {
  const { user } = useAuthStore();
  const [passwordForm] = Form.useForm();

  const handlePasswordChange = async (values) => {
    try {
      const response = await authApi.changePassword(
        values.currentPassword,
        values.newPassword
      );

      if (response.data.success) {
        message.success('密碼修改成功');
        passwordForm.resetFields();
      }
    } catch (error) {
      message.error(error.response?.data?.error || '密碼修改失敗');
    }
  };

  const items = [
    {
      key: 'profile',
      label: (
        <span>
          <UserOutlined />
          個人資料
        </span>
      ),
      children: (
        <Card>
          <Form layout="vertical">
            <Form.Item label="使用者名稱">
              <Input value={user?.username} disabled />
            </Form.Item>
            <Form.Item label="姓名">
              <Input value={user?.full_name} disabled />
            </Form.Item>
            <Form.Item label="Email">
              <Input value={user?.email} disabled />
            </Form.Item>
            <Form.Item label="角色">
              <Input value={user?.role} disabled />
            </Form.Item>
          </Form>
          <p style={{ color: '#999', marginTop: 16 }}>
            如需修改個人資料，請聯絡系統管理員
          </p>
        </Card>
      )
    },
    {
      key: 'password',
      label: (
        <span>
          <LockOutlined />
          修改密碼
        </span>
      ),
      children: (
        <Card>
          <Form
            form={passwordForm}
            layout="vertical"
            onFinish={handlePasswordChange}
            style={{ maxWidth: 400 }}
          >
            <Form.Item
              label="目前密碼"
              name="currentPassword"
              rules={[{ required: true, message: '請輸入目前密碼' }]}
            >
              <Input.Password />
            </Form.Item>
            <Form.Item
              label="新密碼"
              name="newPassword"
              rules={[
                { required: true, message: '請輸入新密碼' },
                { min: 6, message: '密碼至少 6 個字元' }
              ]}
            >
              <Input.Password />
            </Form.Item>
            <Form.Item
              label="確認新密碼"
              name="confirmPassword"
              dependencies={['newPassword']}
              rules={[
                { required: true, message: '請確認新密碼' },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('newPassword') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('兩次輸入的密碼不一致'));
                  }
                })
              ]}
            >
              <Input.Password />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                修改密碼
              </Button>
            </Form.Item>
          </Form>
        </Card>
      )
    },
    {
      key: 'preferences',
      label: (
        <span>
          <SettingOutlined />
          偏好設定
        </span>
      ),
      children: (
        <Card>
          <Form layout="vertical">
            <Form.Item label="Email 通知">
              <Switch defaultChecked />
            </Form.Item>
            <Form.Item label="報價單到期提醒">
              <Switch defaultChecked />
            </Form.Item>
            <Form.Item label="深色模式">
              <Switch />
            </Form.Item>
          </Form>
          <p style={{ color: '#999', marginTop: 16 }}>
            偏好設定功能開發中
          </p>
        </Card>
      )
    }
  ];

  return (
    <div>
      <Card title="系統設定">
        <Tabs items={items} />
      </Card>
    </div>
  );
};

export default Settings;
